import { useOrgContext } from '@/org/contexts/OrgContext'
import { Button, Wrap, WrapItem } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { CheckIcon, CircleIcon } from 'src/icons'

interface Props {
  circlesIds: string[]
  onChange(circlesIds: string[]): void
}

// The circles of the organization — circles only, not roles — as a list to
// click, without the search and its perimeters (#115, Yohan: « juste lister
// les cercles »)
export default function CirclesMultiSelect({ circlesIds, onChange }: Props) {
  const { orgData } = useOrgContext()

  const circles = useMemo(() => {
    if (!orgData) return []
    return orgData.circles
      .filter((circle) => orgData.isCircle(circle.id))
      .map((circle) => ({
        id: circle.id,
        name: orgData.getRole(circle.roleId)?.name ?? '',
      }))
      .sort((a, b) => a.name.localeCompare(b.name))
  }, [orgData])

  const handleToggle = (id: string) =>
    onChange(
      circlesIds.includes(id)
        ? circlesIds.filter((c) => c !== id)
        : [...circlesIds, id]
    )

  return (
    <Wrap spacing={2}>
      {circles.map((circle) => {
        const selected = circlesIds.includes(circle.id)
        return (
          <WrapItem key={circle.id}>
            <Button
              size="sm"
              variant={selected ? 'solid' : 'outline'}
              colorScheme={selected ? 'blue' : undefined}
              leftIcon={
                selected ? <CheckIcon size={16} /> : <CircleIcon size={16} />
              }
              aria-pressed={selected}
              onClick={() => handleToggle(circle.id)}
            >
              {circle.name}
            </Button>
          </WrapItem>
        )
      })}
    </Wrap>
  )
}
